import { useMutation, useQuery } from '@tanstack/react-query'

import {
  type CircleBoothFormResponse,
  deleteCircleBoothApply,
  getCircleApplyDetail,
  getCircleBoothApplyDetail,
  getCircleBoothApplyList,
  getCircleBoothform,
  getCircleBoothInfo,
  getCircleBoothPaidList,
  patchCircleBoothform,
  postCircleBoothform,
  type UserCircleBoothFormPatchRequest,
  type UserCircleBoothFormRequest,
} from '~/features/circle-participation/apis/circleApply'

const CIRCLE_APPLY_KEYS = {
  base: [{ scope: 'circleApply' }] as const,
  detail: (id: string) =>
    [{ ...CIRCLE_APPLY_KEYS.base[0], entity: 'detail', id }] as const,
}

export const useCircleBoothform = (eventId: string) => {
  return useQuery<CircleBoothFormResponse>({
    queryKey: [eventId],
    queryFn: () => getCircleBoothform(eventId),
  })
}

export const useApplyUserCircleBoothform = () => {
  return useMutation({
    mutationFn: ({ userBoothApplication }: UserCircleBoothFormRequest) =>
      postCircleBoothform({ userBoothApplication }),
  })
}

export const useApplyUserCircleBoothformPatch = () => {
  return useMutation({
    mutationFn: ({ userBoothApplication }: UserCircleBoothFormPatchRequest) =>
      patchCircleBoothform({ userBoothApplication }),
  })
}

export const useCircleBoothApplyList = (page: number) => {
  return useQuery({
    queryKey: ['circleBoothApplyList', page],
    queryFn: () => getCircleBoothApplyList(page),
  })
}

export const useCircleBoothApplyDetail = (applicationId: string) => {
  return useQuery({
    queryKey: ['circleBoothApplyDetail', applicationId],
    queryFn: () => getCircleBoothApplyDetail(applicationId),
  })
}

export const useDeleteCircleBooth = () => {
  return useMutation({
    mutationFn: (applicationId: string) =>
      deleteCircleBoothApply(applicationId),
  })
}

export const useCircleBoothInfo = (eventId: string) => {
  return useQuery({
    queryKey: [eventId],
    queryFn: () => getCircleBoothInfo(eventId),
  })
}

export const useCircleBoothPaidList = (applicationId: string) => {
  return useQuery({
    queryKey: ['circleBoothPaidList', applicationId],
    queryFn: () => getCircleBoothPaidList(applicationId),
  })
}

export const useCircleApplyDetail = (id: string) => {
  return useQuery({
    queryKey: CIRCLE_APPLY_KEYS.detail(id),
    queryFn: () => getCircleApplyDetail(id),
  })
}
